import { Link } from "react-router-dom";
import { resolveHref } from "@/lib/routes";

/**
 * Drop-in replacement for react-router <Link> that:
 * - stays internal on the current origin, OR
 * - becomes an absolute <a> when the target belongs to another subdomain
 *   (e.g. marketing → app on production).
 * In the preview / dev environment behavior is identical to <Link>.
 */
export default function SmartLink({ to, children, ...rest }) {
  const resolved = resolveHref(to);
  if (resolved !== to && /^https?:\/\//.test(resolved)) {
    return <a href={resolved} {...rest}>{children}</a>;
  }
  return <Link to={to} {...rest}>{children}</Link>;
}
